import styled from 'styled-components'

interface IFlexContainer {
  wrap?: string
}

export const FlexContainer = styled.div<IFlexContainer>`
  align-items: center;
  display: flex;
  flex-wrap: ${({ wrap }) => (wrap ? 'wrap' : 'nowrap')};
`
